/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BoostTier2SimpleIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAzElEQVR4nGNgGCzA3z/cwS8g4h4Ig9hUNdw3IDzN1z/8l19AxH8o/u3rH15OscH29vYsfgHhk5AMRsG+/uGzQkND2cgy3McnUsQ3IGIfLsPh2D/iiFdoqARJhgcEhCv7BUQ8JGg4Aj/0CoqSJ9oCP/+ItSQY/h+Cw9eTYsFzMiz4QrwFJBseAcajFvwfDaLhlYq+kpHRPhJvgX/EBlIt8A0IX0e0Bf7+4QqkFna+vqGKDIOmuKZLhUOXKpMBCYAqel//iDsgTPVKnxIAAPU85tVyb+Z/AAAAAElFTkSuQmCC)
 */
export const BoostTier2SimpleIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.95 1.4a1.59 1.59 0 0 1 2.1 0l4.9 4A3.37 3.37 0 0 1 19 8v8c0 1.07-.4 2.06-1.05 2.6l-4.9 4c-.65.53-1.45.53-2.1 0l-4.9-4A3.37 3.37 0 0 1 5 16V8c0-1.07.4-2.06 1.05-2.6l4.9-4Z"
        className={colorClass}
      />
    </svg>
  );
};
